import { T } from './theme';
import { FREE_LESSONS, TAG_LESSONS, KS_LESSONS } from '../../config/leckeszam';

const TIER_LABEL = { free: 'FREE', tag: 'TAG', plusz: 'PLUSZ', pro: 'PRO' };

// One sentence per tier. Every statement here must be true for that tier
// (SZINTMATRIX, Plusz 2. kör, Tananyag 1. kör: config/leckeszam.js): FREE 35, TAG 86 (a régi
// TAG-tag mind a 134), Plusz és PRO 134 lecke a Kripto Startból. ksReadable: a Kripto Start
// ténylegesen olvasható leckéi (RLS), ebből látszik a régi TAG-tag.
const tierSentence = (tier, ksReadable) => {
  if (tier === 'pro') return 'PRO-tagként tiéd a Kripto Start teljes anyaga, a Plusz-kurzusok, a Kripto Terminál PRO funkciói és a PRO-anyagok.';
  if (tier === 'plusz') return `Plusz-előfizetőként a Kripto Start mind a ${KS_LESSONS} leckéje és a Plusz-kurzusok a tiéd.`;
  if (tier === 'tag') return ksReadable >= KS_LESSONS
    ? 'A Kripto Start teljes anyaga a tiéd.'
    : `A Kripto Start ${TAG_LESSONS} leckéje a tiéd; Plusszal mind a ${KS_LESSONS} nyílik.`;
  return `A Kripto Start ${FREE_LESSONS} leckéje ingyen a tiéd. TAG-gal ${TAG_LESSONS}, Plusszal mind a ${KS_LESSONS} lecke nyílik.`;
};

const Badge = ({ children, strong }) => (
  <span style={{
    fontSize: 11, fontWeight: 700, letterSpacing: '0.08em',
    padding: '4px 10px', borderRadius: 999,
    color: strong ? T.accent : T.muted,
    background: strong ? T.accentSoft : T.surface,
    border: `1px solid ${strong ? T.accentLine : T.line}`,
  }}>
    {children}
  </span>
);

const CoursesHero = ({ name, tier, ksReadable, showOg, returning, isMobile, children }) => {
  const greeting = name ? `Szia, ${name}!` : returning ? 'Jó újra látni!' : 'Üdv az egyetemen!';

  return (
    <header style={{ padding: isMobile ? '8px 0 24px' : '24px 0 36px' }}>
      <div style={{ display: 'flex', gap: 8, marginBottom: 18, flexWrap: 'wrap' }}>
        <Badge strong={tier !== 'free'}>{TIER_LABEL[tier]}</Badge>
        {showOg && <Badge strong>OG</Badge>}
      </div>

      <h1 style={{
        margin: 0, color: T.text,
        fontSize: isMobile ? 30 : 42, fontWeight: 800,
        letterSpacing: '-0.02em', lineHeight: 1.1,
      }}>
        {greeting}
      </h1>

      <p style={{
        margin: '14px 0 0', maxWidth: 620,
        color: T.muted, fontSize: isMobile ? 15 : 17, lineHeight: 1.55,
      }}>
        {tierSentence(tier, ksReadable)}
        {showOg && ' Korábbi Podia-vásárlóként a Kriptovaluta 3.0 is a tiéd.'}
      </p>

      {children && <div style={{ marginTop: isMobile ? 22 : 28 }}>{children}</div>}
    </header>
  );
};

export default CoursesHero;
